import { client } from "../dtos/Client";
import * as Dtos from "../dtos/Tmd.dtos";

export const usersApi = {
    getUser: (): Promise<Dtos.GetUserResponse> => client.get(new Dtos.GetUser()),
};
